<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

// The API stores headers as a {name: value} object; edit them as an ordered
// row list and convert in the parent on save.
const rows = computed(() =>
  props.modelValue.map((header, index) => ({ ...header, key: index }))
);

const update = (key, field, value) => {
  const next = props.modelValue.map((header, index) =>
    index === key ? { ...header, [field]: value } : header
  );
  emit('update:modelValue', next);
};

const addRow = () => {
  emit('update:modelValue', [...props.modelValue, { name: '', value: '' }]);
};

const removeRow = key => {
  emit(
    'update:modelValue',
    props.modelValue.filter((_header, index) => index !== key)
  );
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-sm font-medium text-n-slate-12">
      {{ $t('AI_AGENT.API_RULES.FORM.HEADERS.LABEL') }}
    </span>
    <div
      v-for="row in rows"
      :key="row.key"
      class="flex items-start gap-2"
      :data-testid="`header-row-${row.key}`"
    >
      <Input
        :model-value="row.name"
        :placeholder="$t('AI_AGENT.API_RULES.FORM.HEADERS.NAME')"
        class="flex-1"
        @update:model-value="update(row.key, 'name', $event)"
      />
      <Input
        :model-value="row.value"
        :placeholder="$t('AI_AGENT.API_RULES.FORM.HEADERS.VALUE')"
        class="flex-1"
        @update:model-value="update(row.key, 'value', $event)"
      />
      <Button
        icon="i-woot-bin"
        slate
        sm
        class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
        @click="removeRow(row.key)"
      />
    </div>
    <div>
      <Button
        icon="i-lucide-plus"
        faded
        slate
        sm
        :label="t('AI_AGENT.API_RULES.FORM.HEADERS.ADD')"
        @click="addRow"
      />
    </div>
  </div>
</template>
